
        import { Mapper } from "../../../../base/utils/mapper";
import { PainScalePhysiotherapyResponseModel } from "../../../../domain/models/consult/pain-scale-physiotherapy-response.model";
import { PainScalePhysiotherapyResponseEntity } from "../entities/pain-scale-physiotherapy-response.entity";

    export class PainScalePhysiotherapyImplementationRepositoryMapper extends Mapper<PainScalePhysiotherapyResponseEntity, PainScalePhysiotherapyResponseModel>{
            mapFrom(param:  PainScalePhysiotherapyResponseEntity):  PainScalePhysiotherapyResponseModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  PainScalePhysiotherapyResponseModel):  PainScalePhysiotherapyResponseEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }